import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

export default function StepNode({ title, role = [], style, actions = {}, onActionClick, selected }) {
  const actionEntries = Object.entries(actions || {});
  return (
    <Card variant={selected ? 'elevation' : 'outlined'} sx={{ width: '100%', height: '100%', borderColor: selected ? 'primary.main' : undefined }} style={style}>
      <CardContent>
        <Typography variant="subtitle1" noWrap>{title}</Typography>
        <div style={{ marginTop: 8, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {role.slice(0, 4).map(r => (
            <Chip key={r} label={r} size="small" />
          ))}
        </div>

        {actionEntries.length > 0 && (
          <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
            {actionEntries.slice(0, 3).map(([k, a]) => (
              <Button variant='outlined' key={k} size="small" onClick={() => onActionClick && onActionClick(k)}>
                {a.title || k}
              </Button>
            ))}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}
